var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "M4 6a8 3 0 1 0 16 0A8 3 0 1 0 4 6" }),
      createElementVNode("path", { d: "M4 6v6a8 3 0 0 0 16 0V6" }),
      createElementVNode("path", { d: "M4 12v6a8 3 0 0 0 16 0v-6" })
    ], -1)
  ]));
}
__name(render, "render");
const database = markRaw({ name: "tabler-database", render });
export {
  database as default
};
//# sourceMappingURL=database.js.map
